<div class="ai-chat-container">
  <div class="sessions-list">
    <h3>Sessions</h3>
    <button (click)="createNewSession()">New Chat</button>
    <ul>
      <li *ngFor="let session of sessions" (click)="selectSession(session)">
        {{ session.title }}
      </li>
    </ul>
  </div>
  <div class="chat-window" *ngIf="selectedSession">
    <h3>{{ selectedSession.title }}</h3>
    <div class="messages">
      <div *ngFor="let msg of messages" class="message {{ msg.role }}">
        <strong>{{ msg.role }}:</strong> {{ msg.content }}
        <div *ngIf="msg.requestPayload">
          <strong>Request:</strong> {{ msg.requestPayload }}
        </div>
        <div *ngIf="msg.responsePayload">
          <strong>Response:</strong> {{ msg.responsePayload }}
        </div>
      </div>
    </div>
    <form [formGroup]="chatForm" (ngSubmit)="sendMessage()">
      <input formControlName="content" placeholder="Type your message...">
      <button type="submit">Send</button>
    </form>
  </div>
</div>
